import { render, staticRenderFns } from "./business_index.vue?vue&type=template&id=7dcb9204&scoped=true&"
import script from "./business_index.vue?vue&type=script&lang=js&"
export * from "./business_index.vue?vue&type=script&lang=js&"
import style0 from "./business_index.vue?vue&type=style&index=0&id=7dcb9204&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcb9204",
  null
  
)

export default component.exports